import likedCover from './assets/collection-liked-cover.jpg'

/**
 * Cover for a liked collection, which has no image of its own. Bundled rather than the nextjs
 * `/images/collection-liked-cover.jpg`: that path is not served on this stack and the resizer appends
 * its params to it, so the image never loaded and the card fell back to the placeholder.
 */
export const COLLECTION_LIKED_COVER: string = likedCover
